import { Component, OnInit, Input } from '@angular/core';
import { Itinerary } from '../itineray.model';
import { UserService } from '../user.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { Role, User } from '../user.model';
import { take } from 'rxjs/operators';
import { ItineraryService } from '../itinerary.service';
import { AssignmentProposalServiceFactory, AssignmentProposalService } from '../assignment-proposal.service';
import { AssignmentProposal } from '../assignment-proposal.model';
import { MatDialog } from '@angular/material/dialog';
import { ItinerarySettingsAssignmentProposalsDialogComponent } from '../itinerary-settings-assignment-proposals-dialog/itinerary-settings-assignment-proposals-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-itinerary-settings-assignment',
  templateUrl: './itinerary-settings-assignment.component.html',
  styleUrls: ['./itinerary-settings-assignment.component.css']
})
export class ItinerarySettingsAssignmentComponent implements OnInit {

  @Input()
  itinerary: Itinerary;

  assignmentProposals: AssignmentProposal[];

  constructor(public userService: UserService, private db: AngularFirestore, public itineraryService: ItineraryService, private assignmentProposalServiceFactory: AssignmentProposalServiceFactory, private matDialog: MatDialog, private matSnackBar: MatSnackBar) { }

  users: User[];

  async ngOnInit() {
    this.users = this.sort(await this.userService.listWhereRole(Role.TRAVEL_ADVISOR).pipe(take(1)).toPromise());
    if (!this.itinerary.proposedAssignees) {
      this.itinerary.proposedAssignees = [];
    }
    this.assignmentProposalServiceFactory.create(this.itinerary.id).list().subscribe((assignmentProposals) => this.assignmentProposals = assignmentProposals);
  }

  ref(path: string) {
    return this.db.doc(path).ref;
  }

  refCompareFn(ref1: firebase.firestore.DocumentReference, ref2: firebase.firestore.DocumentReference) {
    if (ref1 && ref2) {
      return ref1.isEqual(ref2);
    } else {
      if (ref1 === ref2) { return true; }
    }
    return false;
  }

  private sortByField(objects: any[], field: string) {
    return objects.sort((a, b) => {

      if (a[field] === b[field]) {
        return 0;
      } else {
        if (a[field] === null) {
          return 1;
        } else if (b[field] === null) {
          return -1;
        } else {
          return a[field] < b[field] ? -1 : 1;
        }
      }

    });
  }

  sort(users: User[]) {
    users = this.sortByField(users, "email");
    users = this.sortByField(users, "displayName");
    return users;
  }

  getUserByRef(ref: firebase.firestore.DocumentReference) {
    return this.users.find((user: User) => user.id === ref.id);
  }

  getAssignmentProposalByUserRef(ref: firebase.firestore.DocumentReference) {
    return this.assignmentProposals.find((proposal) => proposal.user.isEqual(ref));
  }

  userAlreadyHasAProposal(user: User) {
    return this.assignmentProposals.find((proposal) => proposal.user.isEqual(this.db.doc('/users/' + user.id).ref)) != null;
  }

  async addAssignmentProposals() {
    const currentProposedAssigneeIds = this.itinerary.proposedAssignees.map((ref) => ref.id);
    const newProposedAssigneeIds: string[] = await this.matDialog.open(ItinerarySettingsAssignmentProposalsDialogComponent, {
      width: '75%',
      data: { ids: currentProposedAssigneeIds, users: this.users }
    }).afterClosed().toPromise();
    if (newProposedAssigneeIds && newProposedAssigneeIds.length > 0) {

      const allProposedAssigneeIds = [...new Set(currentProposedAssigneeIds.concat(newProposedAssigneeIds))];

      if (confirm("Sei veramente sicuro? Le proposte saranno inviate immediatamente e non potrai più rimuovere i Travel Advisors selezionati.")) {
        this.itinerary.proposedAssignees = allProposedAssigneeIds.map((id) => this.db.doc("users/" + id).ref);
        await this.itineraryService.update({ id: this.itinerary.id, proposedAssignees: this.itinerary.proposedAssignees });
        this.matSnackBar.open("✔️ Ottimo, a breve saranno invate le nuove proposte. La configurazione è stata salvata.", null, {
          duration: 3000
        });
      }
    }
  }

}
